'use strict';

import { appState, addDynEvents } from './appState.js';
import { mobileNav, setMobileNavInstance } from './mobileNav.js';
import { initFloatingLabel } from './forms.js';
import { VarMgr } from './VarMgr.js';
import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { getUrlParam, urlSafe } from './urlTools.js';
import { hashCopy } from './clipboardTools.js';
import { new_floatTopAlwaysVisible } from './floatTop.js';
import { jconnanimInit } from './connanim.js';
import { initHoverTitle } from './HoverTitle.js';
import { scrollAnimate } from './Scrolls.js';
import { scrollDisableOverlay, scrollEnableOverlay } from './Overlay.js';
//import { addDynEvents } from './DynEvents.js';
import { addStatCounter } from './StatCounter.js';
import { initEnergyFieldMini } from './EnergyMiniCounter.js';
import { getJsonData, getAnimScript } from './dataHelpers.js';
import { addSceneCounter } from './SceneCounter.js';
import { minimizableInitLoad } from './minimizable.js';
import { initSelect2year, initSelect2country } from './SelectFancy.js';
import { loadPageConnect } from './page-connect.js';
import { loadChat } from './page-chat.js';
import { loadForConnect, loadMiracles } from './page-miracles.js';
import { loadLibrary } from './page-library.js';
import { loadConnectStats } from './page-connect-stats.js';
import { loadConnectStatsDetailed } from './page-connect-stats-detailed.js';
import { loadEnergyField } from './page-energy-field.js';
import { loadArchive } from './page-archive.js';
import { loadAuth } from './page-auth.js';
import { loadRegister } from './page-register.js';
import { loadProfile } from './page-profile.js';
import { loadCreatePin } from './page-create-pin.js';
import { loadCreateNewPin } from './page-create-new-pin.js';
import { loadImportPin } from './page-import-pin.js';



function testReferer() {
    const referrer = document.referrer;
    const currentDomain = window.location.hostname;

    return referrer && referrer.includes(currentDomain);
}

function initResizeEvent() {
    var rtime,
        timeout = false,
        delta = 200,
        rstarted = false,
        jq_resizeend = function () {
            if (new Date().getTime() - rtime.getTime() < delta) {
                setTimeout(jq_resizeend, delta);
            } else {
                timeout = false;
                $(window).trigger('jq-resize-end', [$('.jq-size-calc').width(), false]);
                rstarted = false;
            }
        };

    $(window).on('resize.on3', function () {
        if (rstarted === false) {
            rstarted = true;
            $(window).trigger('jq-resize-start');
        }

        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(jq_resizeend, delta);
        }

        //$( window ).trigger( 'jq-resize', [ $( ".jq-size-calc" ).width(), false ] );
    });
}

function runemdecrajax() {
    // @ts-ignore
    if (typeof emdecr == 'function') {
        $('.emdecrajax').each(function () {
            // @ts-ignore
            let em = emdecr($(this).data('k'), true);
            $(this).html($(this).closest('a').length ? em : '<a href="mailto:' + em + '">' + em + '</a>');
            $(this).removeClass('emdecrajax').data('k', '').attr('data-k', '');
        });
    }
}

function initCookieEvent() {
    if ($('.cookie-notify-container').length) {
        const $cookieContainer = $('.cookie-notify-container');
        const checkCookieScroll = function () {
            const el = $cookieContainer.get(0);
            if (!el) {
                return;
            }

            const hasScroll = el.scrollHeight > el.clientHeight;
            if (hasScroll) {
                $cookieContainer.attr('data-withscrollbar', '1');
                scrollDisableOverlay('cookie');
            } else {
                $cookieContainer.removeAttr('data-withscrollbar');
                scrollEnableOverlay('cookie');
            }
        };

        $cookieContainer.on('click', '.accept,.close', function () {
            if ($(this).hasClass('no-action')) {
                return;
            }

            let myDate = new Date();
            myDate.setMonth(myDate.getMonth() + 12);
            document.cookie = 'cookieAccept=accepted;expires=' + myDate + ';domain=.' + VarMgr.get('thDOMAIN') + ';path=/';
            $('.cookie-notify-container').hide();

            $cookieContainer.removeAttr('data-withscrollbar');
            scrollEnableOverlay('cookie');

            $('.act-btns').show();

            setTimeout(function () {
                ajaxWrapNew({
                    type: 'POST',
                    data: {
                        ajax: 1,
                        action: 'cookieAccept'
                    },
                    success: function (data) {
                        ResponseDispatcher.handle(data, 'cookieAccept');
                    },
                    dataType: 'json'
                });
            }, 100);
        });
        $('.cookie-notify-call').on("click", function (event) {
            event.preventDefault();

            $('.cookie-notify-container').show();
            $('.act-btns').hide();

            checkCookieScroll();
        });

        $(window).on('jq-resize-end', function (event, w) {
            checkCookieScroll();
        });

        checkCookieScroll();
    }
}

function initOptionsSwitcher() {
    // options swičošana;
    var siteOption = function (key, on, toggle) {
        const action = 'cht-optionsave';
        const addData = {};

        $('body').toggleClass('off-' + key, !on);

        if (key == 'bganim') {
            VarMgr.set('PAUSE_ANIM', !on);
            if (VarMgr.has('globalBgAnim')) {
                VarMgr.get('globalBgAnim').togglePause(!on);
            }
        }
        else if (key == 'staranim') {
            VarMgr.set('PAUSE_STAR', !on);
            dispatchEvent(new CustomEvent('star:togglePause', { detail: { paused: !on } }));
            /* if (typeof goTogglePause != 'undefined') {
                goTogglePause(!on);
            } */
        }

        ajaxWrapNew({
            method: 'POST',
            data: $.extend({
                ajax: 1,
                action: action,
                key: key,
                on: on ? 1 : 0
            }, addData),
            success: function (data) {
                if (typeof data.on != 'undefined') {
                    toggle(data.on);
                }
                ResponseDispatcher.handle(data, action);
            },
            dataType: 'json'
        });
    };

    // options papildmeņu atvēršana no meņu
    var optionsAction = function (action, el) {
        if (!action) {
            return;
        }

        switch (action) {
            case 'cht-options':
                if ($(el).hasClass('selected')) {
                    $(el).removeClass('selected');
                    $(el).closest('.nvi').find('.nv-options').remove();
                    return;
                } else {
                    $(el).addClass('selected');
                }
                break;
        }

        if (typeof window['chtActionV2AjaxPosting'] != 'undefined') {
            if (window['chtActionV2AjaxPosting']) {
                return false;
            }
        }
        window['chtActionV2AjaxPosting'] = true;
        ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: action
            },
            success: function (data) {
                ResponseDispatcher.handle(data, action);
            },
            complete: function () {
                window['chtActionV2AjaxPosting'] = false;
            },
            dataType: 'json'
        });
    };

    $('body').on('click.cht', '.nv-switch', function (event) {
        if ($(this).closest('.nv-switch-label').length) {
            return;
        }
        let on = $(this).hasClass('on') ? false : true;
        $(this).toggleClass('on', on).toggleClass('off', !on);
    });

    $('body').on('click.cht', '.nv-switch-label', function (event) {
        if ($(event.target).closest('a').length) {
            return;
        }
        let el = $(this).find('.nv-switch').get(0),
            on = $(el).first().hasClass('on') ? false : true;

        let toggle = (on) => {
            $(el).toggleClass('on', on).toggleClass('off', !on);
        };

        if ($(this).closest('.opt-switcher').length) {
            siteOption($(el).data('key'), on, toggle);
        } else {
            toggle(on);
        }
    });

    $('body').on('click.cht', '.chtgl', function (event) {
        if ($(this).is('a')) {
            event.preventDefault();
        }

        event.stopPropagation();
        if ($(this).hasClass('no-action') && !(event && event.originalEvent instanceof MouseEvent && event.originalEvent.ctrlKey)) {
            return;
        }
        optionsAction($(this).data('action'), this);
    });
}

function initTextareaLikeInput(selector, disableBR = true, offset = 16) {
    var clear = function (box) {
        box.defHeight = $(box).data('defheight') || $(box).height();
        box.curHeight = $(box).height();
    };

    var update = function (box, data) {
        const isinit = data && data.init;
        const forceupdate = data && data.forceupdate;

        box.prevHeight = box.curHeight;
        box.style.height = '1px';
        box.curHeight = $(box).prop('scrollHeight');
        $(box).height(box.curHeight - offset);
    };

    $('body').on('blur focus keyup input change', selector, function (event, data) {
        update(this, data);
    });

    if (disableBR) {
        $('body').on('keypress', selector, function (event) {
            return event.which != 13;
        });
    }

    $('body').on('paste', selector, function (event) {
        event.preventDefault();

        let txt = '';
        // @ts-ignore
        if (event.clipboardData || event.originalEvent.clipboardData) {
            // @ts-ignore
            txt = (event.originalEvent || event).clipboardData.getData('text/plain');
            // @ts-ignore
        } else if (window.clipboardData) {
            // @ts-ignore
            txt = window.clipboardData.getData('Text');
        }

        if (disableBR) {
            txt = txt.replace(/(\r\n|\n|\r)+/gm, " ");
            txt = txt.trim();
        }

        if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, txt);
        } else {
            document.execCommand('paste', false, txt);
        }
    });

    $(window).on('jq-resize-end', function (event, w) {
        $(selector).each(function () {
            clear(this);
            update(this, {
                forceupdate: 1
            });
        });
    });

    $(selector).trigger('change', { init: true, forceupdate: true });

    addDynEvents((context, calledwhen) => {
        if (calledwhen !== 'afterShow') return;
        $(selector).each(function () {
            clear(this);
            update(this, {
                forceupdate: 1
            });
        });
    });
}

function initFloatingMenu(sel) {
    const self = this;

    this.sel = sel;

    const defaultOffset = 10;
    var mnbHeight = $('.mnb').height();
    var checkTopPos = 0;
    var checkTopOffset = 0;
    var isOver;
    var calcOver;
    var calcResize;
    var getCheckTopPos = function () { return 100; };
    var overContentDisabled = false;

    calcOver = () => {
        return $('.mnb').offset().top + mnbHeight > checkTopPos + checkTopOffset;
    };

    calcResize = () => {
        mnbHeight = $('.mnb').height();
        checkTopPos = getCheckTopPos();
    };

    if ($('.smallFloatingCheck').length) {
        getCheckTopPos = () => {
            return $('.smallFloatingCheck').offset().top;
        };

        overContentDisabled = $('.smallFloatingCheck').hasClass('disabled');

        checkTopPos = getCheckTopPos();
        checkTopOffset = $('.smallFloatingCheck').data('offset') || 0;
    } else {
        let done = false;
        $('main .nbox').not('.nbox-admin').first().find('.nbox-b .ml-box').children().not('.admin-links-right').first().each(function () {
            if (!done) {
                getCheckTopPos = () => {
                    return $(this).offset().top;
                };

                checkTopPos = getCheckTopPos();
                checkTopOffset = defaultOffset;
                done = true;
            }
            return false;
        });

        if (!done) {
            $('main .nbox').not('.nbox-admin').first().find('.nbox-b').children().not('.admin-links-right').first().each(function () {
                if (!done) {
                    getCheckTopPos = () => {
                        return $(this).offset().top;
                    };

                    checkTopPos = getCheckTopPos();
                    checkTopOffset = defaultOffset;
                    done = true;
                }
                return false;
            });
        }
    }


    $(window).on('resize', function () {
        calcResize();
        isOver = calcOver();
        $(sel).toggleClass('overContent', isOver && !overContentDisabled);
    });

    $(window).on('scroll', function () {
        isOver = calcOver();
        $(sel).toggleClass('overContent', isOver && !overContentDisabled);
    });

    calcResize();
    isOver = calcOver();
    $(sel).toggleClass('overContent', isOver && !overContentDisabled);

    // saglabājam platumu ar back ikonu un tekstu;
    this.originalWidth = $('.mnb').width();
    this.calcWidth = $(sel).data('calcwidth');
    if (!this.calcWidth) {
        this.calcWidth = $('main .nbox').not('.nbox-admin').first().find('.nbox-b').width();
        if (this.calcWidth) {
            this.calcWidth += 60;
        }
    }
    if (!this.calcWidth) {
        return;
    }

    $(sel).addClass('init');

    this.isSmall = false;

    var calcIsSmall = () => {
        $(sel).removeClass('isSmall');
        this.isSmall = $('.mnb').offset().left + this.originalWidth > Math.ceil(($(window).width() - this.calcWidth) / 2);
        $(sel).toggleClass('isSmall', this.isSmall);
    };
    calcIsSmall();

    $(window).on('jq-resize-end', calcIsSmall);
}

// for login?
function processingPage(on) {
    var interval;
    if (on) {
        $('.wbouter').css({
            opacity: .1
        });
        $('body').append([
            '<div class="fullPop withOverlay fullPage lock-screen processing-screen">',
            '<div class="fullPageBox"><div class="inner">',
            //'<div class="lock-screen-info"><div>'+transGet('Connecting')+' <span class="runningDots"></span></div></div>',
            '<div class="lock-screen-info"><div><span class="runningDots">...</span></div></div>',
            '</div></div>',
            '</div>'
        ].join(''));

        var $runningDots = $('.processing-screen').find('.runningDots');
        interval = setInterval(() => {
            $runningDots.text($runningDots.text().length < 3 ? $runningDots.text() + '.' : '');
        }, 500);
        $('.processing-screen').data('interval', interval);
    } else {
        $('.wbouter').css({
            opacity: ''
        });
        if ($('.processing-screen').length) {
            interval = $('.processing-screen').data('interval');
            clearInterval(interval);
        }
        $('.processing-screen').remove();
    }
}
// @ts-ignore
window.processingPage = processingPage;




async function run() {
    initResizeEvent();
    runemdecrajax();

    // izveidojam mobile menju
    if ($('.main-nav').length > 0) {
        setMobileNavInstance(new mobileNav());
    }

    // cookie eventi
    initCookieEvent();

    // elementu dublēšana
    $('.cpyel').each(function () {
        $($(this).data('cpyto')).empty().append($(this).clone());
    });

    initOptionsSwitcher();

    // dinamiski pievienos eventus arī ajax contentam ar addDynEvents()
    // TODO: jāpārtaisa gudrāk ka pievieno tiem kas tagad ir, un pēc ajax pārējiem; tam registry jāuztaisa;
    initTextareaLikeInput('.textarea-like-input');

    initHoverTitle('.hoverTitle', 'body');


    $('body').on('click', '.scrolltohash', function (event) {
        var hash = $(this).data('hash');
        if (!hash) {
            hash = $(this).attr('href').split('#')[1] || '';
        }

        if (hash && $('#' + hash).length) {
            event.preventDefault();

            const duration = 500;
            const scrollTop = $(window).scrollTop();
            const scrollTo = $('#' + hash).offset().top - parseInt($(this).data('offset') || 0);

            scrollAnimate(scrollTop, scrollTo, duration, () => {
                appState.historyInstance.push('scrolltohash', { value: scrollTop.toString() });
            });
        }
    });

    $('body').on('click', '.defback', function (event) {
        let h = getUrlParam('h') ?? null;
        if (h && testReferer()) {
            event.preventDefault();
            history.back();
        }
    });

    $('body').on('click', '.repllink', function (event) {
        event.preventDefault();
        const targetUrl = this.href; // Kur lietotājs reāli gribēja iet
        const replaceBackUrl = $(this).data('replacebackurl'); // URL, ko ielikt vēsturē
        // 1. Pārrakstām pašreizējo vēstures ierakstu!
        // Pārlūks tagad domā, ka lietotājs atrodas '/brinumi' (kaut arī vizuāli lapa nemainās)
        //window.history.replaceState(null, '', replaceBackUrl);
        //window.history.pushState(null, '', replaceBackUrl); // te jātaisa ar parametru lai darbotos.

        window.history.replaceState({ forceReload: true }, ''); // Atzīmējam, ka šis ir īpašs stāvoklis, kas prasa lapas pārlādi
        window.history.pushState({ forceReload: true }, '', replaceBackUrl); // Pievienojam vēstures ierakstu ar replaceBackUrl, lai lietotājs redzētu šo URL adresi pārlūkā

        // 2. Normāli aizsūtām lietotāju uz izvēlēto mērķi
        urlSafe.assign(targetUrl);
    });

    $('body').on('click', '.hashCopy', function (event) {
        event.preventDefault();
        hashCopy(this, event);
    });

    if ($('.floatingMenu').length) {
        new initFloatingMenu('.floatingMenu');
    }

    initFloatingLabel();

    if ($('.floattop-active').length) {
        new_floatTopAlwaysVisible({
            heightFixed: 70,
            beforeClass: 'before-floattop-F2',
        });
    }

    // pin izsaukšana no tekstiem: sub action = create, forgot, change;
    $('body').on('click', '.jq-gl-pin', function (event) {
        event.preventDefault();

        ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'glPIN',
                sub: $(this).data('action')
            },
            success: function (data) {
                ResponseDispatcher.handle(data, 'glPIN');
            },
            dataType: 'json'
        });
    });

    // Animācija meņu;
    $('.jconnanim.v1').first().each(function () {
        jconnanimInit(this);
    });


    // addXHover lai nofiksējas redzams pie klikšķa, un lai aizveras klikšķa ārpusē;
    $('body').on('click', '.XHv1', function (event) {
        event.preventDefault();

        $('.XHv1').not(this).removeClass('XHv1-open');
        $(this).toggleClass('XHv1-open');
    });
    $(window).on('jq-outclick', function (event, clickEvent) {
        if (clickEvent && $(clickEvent.target).closest('.XHv1').length === 0) {
            $('.XHv1').removeClass('XHv1-open');
        }
    });

    if ($('.showPageDelay').length) {
        setTimeout(function () {
            $('.showPageDelay').addClass('main-visible');
            setTimeout(function () {
                $('.showPageDelay').removeClass('showPageDelay main-visible');

            }, 2000);
        }, 100);
    }

    if ($('.selCountry, .selCity, .select2year').length) {
        (async () => {
            initSelect2year();
            initSelect2country();
        })();
    }


    const statCounter = VarMgr.get('statCounter');
    if (statCounter) {
        addStatCounter(statCounter.connectSID, statCounter.connectIID, statCounter.iid);
    }

    const energyFieldMiniInit = VarMgr.get('energyFieldMiniInit');
    if (energyFieldMiniInit) {
        initEnergyFieldMini();
    }

    if (typeof modAnimationRun !== 'undefined') {
        const autoinitScenes = document.querySelectorAll('.app-scene-animation-autoinit');
        autoinitScenes.forEach(script => {
            const animationData = JSON.parse(script.textContent);
            if (animationData && animationData.thisScript) {
                const thisScript = getAnimScript(animationData.thisScript) || {};
                if (thisScript.animations) {
                    const thisAnim = new modAnimationRun({
                        groups: thisScript.groups,
                        animations: thisScript.animations,

                        animationContainer: '.sceneAnimation',
                    }, $(animationData.selector).get(0));
                }
                if (animationData.withCounters) {
                    addSceneCounter(animationData.connectSID, animationData.connectIID, animationData.iid);
                }
            }
        });
    }

    if ($('.showOnLoad').length) {
        $('.showOnLoad').animate({ opacity: 1 }, 300).promise().then(() => {
            /* $('.withOvl').addClass('removeOvl'); */
            /* setTimeout(function () {
                $('.withOvl').removeClass('withOvl');
            }, 300); */
        });
    }
    if ($('.delayLink').length) {
        $('body').on('click', '.delayLink', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            if (href) {
                $(this).animate({ opacity: 0 }, 300).promise().then(() => {
                    window.location.href = href;
                });
            }
        });
    }
    if ($('.loginSmt').length) {
        if (VarMgr.get('UID') > 0) {
            $('.loginSmt').each(function () {
                $(this).attr('href', $(this).data('alternateurl'));
            });
        }

    }

    minimizableInitLoad();
    await runPageSpecific();

    appState.historyInstance.init();
    appState.historyInstance.initRefresh();
}

async function runPageSpecific() {

    const pageType = document.body.dataset.pageType;
    if (!pageType) {
        return;
    }

    /* switch (pageType) {
        case 'connect':
            (async () => {
                const moduleConnect = await import("./page-connect.js");
                moduleConnect.loadPageConnect();

                const moduleChat = await import("./page-chat.js");
                moduleChat.loadChat();

                const moduleMiracles = await import("./page-miracles.js");
                moduleMiracles.loadMiracles();
                moduleMiracles.loadForConnect();
            })();
            break;
        case 'miracles':
            (async () => {
                const moduleChat = await import("./page-chat.js");
                moduleChat.loadChat();

                const moduleMiracles = await import("./page-miracles.js");
                moduleMiracles.loadMiracles();
            })();
            break;
        case 'chat':
            (async () => {
                const module = await import("./page-chat.js");
                module.loadChat();
            })();
            break;
        case 'library':
            (async () => {
                const moduleChat = await import("./page-chat.js");
                moduleChat.loadChat();

                const moduleLibrary = await import("./page-library.js");
                moduleLibrary.loadLibrary();
            })();
            break;

        case 'connect-stats':
            (async () => {
                const moduleConnectStats = await import("./page-connect-stats.js");
                moduleConnectStats.loadConnectStats();

                const moduleConnectStatsDetailed = await import("./page-connect-stats-detailed.js");
                moduleConnectStatsDetailed.loadConnectStatsDetailed();
            })();
            break;

        case 'connect-stats-detailed':
            (async () => {
                const moduleConnectStatsDetailed = await import("./page-connect-stats-detailed.js");
                moduleConnectStatsDetailed.loadConnectStatsDetailed();
            })();
            break;

        case 'energy-field':
            (async () => {
                const moduleEnergyField = await import("./page-energy-field.js");
                moduleEnergyField.loadEnergyField();
            })();
            break;

        case 'archive':
            (async () => {
                const moduleArchive = await import("./page-archive.js");
                moduleArchive.loadArchive();
            })();
            break;

        case 'auth':
            (async () => {
                const module = await import("./page-auth.js");
                module.loadAuth();
            })();
            break;

        case 'register':
            (async () => {
                const module = await import("./page-register.js");
                module.loadRegister();
            })();
            break;

        case 'profile':
            (async () => {
                const module = await import("./page-profile.js");
                module.loadProfile();
            })();
            break;
    } */
    switch (pageType) {
        case 'connect':
            loadPageConnect();
            loadChat();
            loadForConnect();
            loadMiracles();
            break;
        case 'miracles':
            loadChat();
            loadMiracles();
            break;
        case 'chat':
            loadChat();
            break;
        case 'library':
            loadChat();
            loadLibrary();
            break;

        case 'connect-stats':
            loadConnectStats();
            loadConnectStatsDetailed();
            break;

        case 'connect-stats-detailed':
            loadConnectStatsDetailed();
            break;

        case 'energy-field':
            loadEnergyField();
            break;

        case 'archive':
            loadArchive();
            break;

        case 'auth':
            loadAuth();
            break;

        case 'register':
            loadRegister();
            break;

        case 'profile':
            loadProfile();
            break;

        case 'create-pin':
            loadCreatePin();
            break;
        case 'create-new-pin':
            loadCreateNewPin();
            break;
        case 'import-pin':
            loadImportPin();
            break;
    }
}

function load() {
    var w = $('.jq-size-calc').width();
    $(window).trigger('jq-resize', [w, true]);
    $(window).trigger('jq-resize-end', [w, true]);

    $( window ).on( "click", jq__click );
}

function jq__click(event) {
    if (event.which == 1) {
        $(window).trigger('jq-outclick', [event]);
    }
}

function click(event) {
    // Tīrajā JS kreisais klikšķis ir event.button === 0
    // (jQuery izmantoja event.which == 1)
    if (event.button === 0) {
        // Izveidojam un izšaujam savu eventu, padodot oriģinālo eventu līdzi kā 'detail'
        const customEvent = new CustomEvent("jq-outclick", {
            detail: event
        });
        window.dispatchEvent(customEvent);
    }
}

addEventListener('DOMContentLoaded', run);
addEventListener('load', load);
//addEventListener('click', click);



